import { trackPendoEvent } from "../../../utils/pendo/pendoUtils";

/**
 * Handler for clicking the Settings breadcrumb link
 * @param {Object} params
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {Object} params.user - Current user object
 * @param {string} params.account - Site identifier (dev, ssmh, etc)
 * @param {Object} params.history - React Router history object
 */
export const handleSettingsClick = ({ dispatch, user, account, history }) => {
  try {
    trackPendoEvent(dispatch, "Physician_Breadcrumbs_Settings", {
      username: user?.email,
      account
    });
  } catch (error) {
    console.error("Error dispatching physician breadcrumbs Pendo event:", error);
  }
  history.push("/settings");
};

/**
 * Handler for clicking the Physicians breadcrumb link
 * @param {Object} params
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {Object} params.user - Current user object
 * @param {string} params.account - Site identifier (dev, ssmh, etc)
 * @param {Object} params.history - React Router history object
 */
export const handlePhysiciansClick = ({ dispatch, user, account, history }) => {
  try {
    trackPendoEvent(dispatch, "Physician_Breadcrumbs_Physicians", {
      username: user?.email,
      account
    });
  } catch (error) {
    console.error("Error dispatching physician breadcrumbs Pendo event:", error);
  }
  history.push("/physicians-settings");
};
